import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import Toggle from 'material-ui/Toggle'
import { validateLogoCategory, maxPlaceholderDescChar } from 'utils/CustomValidation'

import Styles from './index.scss'
import StylesJS from './styles'

const renderTitle = title => (
  <div>
    {title}
  </div>
)

const inputNotEmpty = (input) => {
  if (
    input.data.productType !== '' &&
    input.data.name !== '' &&
    input.data.serviceTitle !== '' &&
    input.data.serviceDesc !== '' &&
    input.data.serviceDesc.length <= maxPlaceholderDescChar &&
    input.data.logo !== ''
  ) {
    return true
  }

  return false
}

const onChangeLogo = (
  onChange,
  setFileLogoCategory,
  setErrorLogoInputText,
) => (e) => {
  const logoFile = e.target.files[0]
  if (validateLogoCategory(logoFile)) {
    setFileLogoCategory(logoFile)
    const reader = new FileReader()
    reader.onload = onChange('logo')
    reader.readAsDataURL(logoFile)
    setErrorLogoInputText('')
  } else {
    setErrorLogoInputText('Your file exceed 500kb')
  }
}

const renderActions = props => (
  <div className={Styles['btn-container']}>
    <button
      className={Styles['btn-cancel']}
      onClick={props.onCloseModal(false)}
    >
      Cancel
    </button>
    <button
      className={`${Styles['btn-confirm']} ${inputNotEmpty(props) ? '' : Styles['btn-disabled']}`}
      onClick={props.onClickConfirm}
      disabled={!inputNotEmpty(props)}
    >
      Confirm
    </button>
  </div>
)

const ModalAddEdit = props => (
  <Dialog
    title={renderTitle(props.title)}
    titleStyle={StylesJS.titleStyles}
    actions={renderActions(props)}
    actionsContainerStyle={StylesJS.actionsStyles}
    bodyStyle={StylesJS.contentStyles}
    open={props.isModalOpen}
    onRequestClose={props.onCloseModal(false)}
  >
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Service type<sup>*</sup></div>
      <div className={Styles['field-input']}>
        <select
          onChange={props.setInputDataAdd('productType')}
          value={props.data.productType}
          disabled={props.isEditCategory}
        >
          <option value="">--- Select product type ---</option>
          {props.productTypes.rows.map(type => (
            <option value={type.id} key={type.id}>{type.name}</option>
          ))}
        </select>
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Category name<sup>*</sup></div>
      <div className={Styles['field-input']}>
        <input
          className={Styles['input-tag']}
          onChange={props.setInputDataAdd('name')}
          value={props.data.name}
        />
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Placeholder</div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Service title<sup>*</sup></div>
      <div className={Styles['field-input']}>
        <input
          className={Styles['input-tag']}
          onChange={props.setInputDataAdd('serviceTitle')}
          value={props.data.serviceTitle}
        />
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Service Description Placeholder<sup>*</sup></div>
      <div className={Styles['field-input']}>
        <textarea
          className={`${Styles['input-textArea']} ${props.data.serviceDesc.length > maxPlaceholderDescChar ? Styles['alert-error-box'] : ''}`}
          onChange={props.setDescPlaceholder}
          value={props.data.serviceDesc}
        />
        <div className={`${Styles['sum-text-container']} ${props.data.serviceDesc.length > maxPlaceholderDescChar ? Styles['alert-error-text'] : ''}`}>
          {props.data.serviceDesc.length > maxPlaceholderDescChar && (
            <span className={Styles['error-desc-text-position']}>
              {`text input cannot exceed ${maxPlaceholderDescChar} characters`}
            </span>
          )}
          <span className={Styles['sum-text']}>{props.data.serviceDesc.length}/{maxPlaceholderDescChar}</span>
          {props.data.serviceDesc.length <= maxPlaceholderDescChar && (
            <span>In general add maximum char accepted</span>
          )}
        </div>
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Icon<sup>*</sup></div>
      <div className={Styles['field-input']}>
        <input
          type="file"
          onChange={
            onChangeLogo(
              props.setInputDataAdd,
              props.setFileLogoCategory,
              props.setErrorLogoInputText,
            )
          }
          accept="image/*"
        />
        <span className={Styles.imgNote}>
          Please make sure that your icon is perfectly square for better experience
        </span>
        <span className={Styles.imgNote}>
          ( maxSize : 500kb )
        </span>
        <span className={Styles.imgErroMsg}>
          {props.errorLogoInputText}
        </span>
        <img
          src={props.data.logo}
          alt=""
          className={Styles.imageContainer}
          onClick={props.setOpenModalPreviewLogo(true)}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Show in service editor</div>
      <div className={Styles['field-input']}>
        <Toggle
          defaultToggled={props.data.isUsable}
          onToggle={props.setInputDataAdd('isUsable')}
        />
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Show on search/browse</div>
      <div className={Styles['field-input']}>
        <Toggle
          defaultToggled={props.data.isSearchable}
          onToggle={props.setInputDataAdd('isSearchable')}
          disabled // temporary disabled because adding new category not yet handle by platform
        />
      </div>
    </div>
  </Dialog>
)

ModalAddEdit.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  productTypes: PropTypes.shape({
    rows: PropTypes.array,
  }).isRequired,
  setInputDataAdd: PropTypes.func.isRequired,
  data: PropTypes.shape({
    productType: PropTypes.string,
    name: PropTypes.string,
    serviceTitle: PropTypes.string,
    serviceDesc: PropTypes.string,
    isUsable: PropTypes.bool,
    isSearchable: PropTypes.bool,
    logo: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  isEditCategory: PropTypes.bool.isRequired,
  setDescPlaceholder: PropTypes.func.isRequired,
  setFileLogoCategory: PropTypes.func.isRequired,
  errorLogoInputText: PropTypes.string.isRequired,
  setErrorLogoInputText: PropTypes.func.isRequired,
  setOpenModalPreviewLogo: PropTypes.func.isRequired,
}

renderActions.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
}

export default ModalAddEdit
